import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { stripePublishableKey } from '../config/stripe';
import React from 'react';

export const StripeProvider = ({ children, clientSecret }: { children: React.ReactNode; clientSecret?: string }) => {
    const stripePromise = loadStripe(stripePublishableKey);

    const options = clientSecret ? {
        clientSecret,
        appearance: {
            theme: 'stripe' as const,
        },
    } : undefined;

    return (
        <Elements stripe={stripePromise} options={options}>
            {children}
        </Elements>
    );
};